import { render, staticRenderFns } from "./EditAssistant.vue?vue&type=template&id=920dea08&scoped=true"
import script from "./EditAssistant.vue?vue&type=script&lang=js"
export * from "./EditAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920dea08",
  null
  
)

export default component.exports